module.exports = __webpack_public_path__ + "img/25.8e6819f4.jpg";